import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import axios from "axios";
import Select from "react-select";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../../components/shared/GlobalState";
import {
  ArrowLeftIcon,
  PlusIcon,
  CurrencyDollarIcon,
  UserIcon,
  CalendarIcon,
  TagIcon,
  ClipboardDocumentIcon,
} from "@heroicons/react/24/solid";

const ExpenseUpdateChild = ({ expenseRecord }) => {
  dayjs.extend(utc);
  let navigate = useNavigate();
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);
  const [income, setIncome] = useState(expenseRecord);
  const [churchMembers, setChurchMembers] = useState(null);
  const [categoryList, setCategoryList] = useState();
  const [churchList, setChurchList] = useState();
  const [startDate, setStartDate] = useState(dayjs(expenseRecord?.date));
  const [formData, setFormData] = useState({
    category_id: expenseRecord?.category_id?._id,
    expense_title: expenseRecord?.expense_title,
    description: expenseRecord?.description,
    member_id: expenseRecord?.member_id?._id,
    date: expenseRecord?.date,
    amount: expenseRecord?.amount,
    transfer_source: expenseRecord?.transfer_source,
    status: expenseRecord?.status,
  });

  //Category
  useEffect(() => {
    const getDataFromServer = () => {
      let userToken = localStorage.getItem("token");

      let urlLink = `${process.env.REACT_APP_API_URL}/category/expense/${user.church_id}`;

      const config = {
        method: "GET",
        url: urlLink,
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      };
      axios(config)
        .then(function (response) {
          //console.log(JSON.stringify(response.data));
          const oldData = response.data.Categorys;
          const updatedData = oldData.map((data) => {
            return {
              value: data._id,
              label: data.category_name,
            };
          });

          setCategoryList(updatedData);
        })
        .catch(function (err) {
          console.log("error api call ", err.response.data.message);
        });
    };
    getDataFromServer();
  }, []);

  //   Church Members
  useEffect(() => {
    let userToken = localStorage.getItem("token");
    const config = {
      method: "get",
      url: `${process.env.REACT_APP_API_URL}/user/church/expense/${user.church_id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      // data: { ...formData },
    };

    axios(config)
      .then(function (response) {
        //console.log(response.data);
        const members = response.data.members;
        setChurchMembers(
          members.map((member) => ({
            value: member._id,
            label:
              member.first_name +
              " " +
              member.last_name +
              " (" +
              member.user_type +
              ")",
          }))
        );
      })
      .catch(function (error) {
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeList", "/expense");
      });
  }, []);

  const handleChange = ({ currentTarget: input }) => {
    setFormData({
      ...formData,
      [input.name]: input.value,
    });
  };

  const handleUpdateExpense = (e) => {
    e.preventDefault();
    let userToken = localStorage.getItem("token");

    const config = {
      method: "patch",
      url: `${process.env.REACT_APP_API_URL}/expense/update/${income?.id}`,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
      data: { ...formData },
    };
    axios(config)
      .then(function (response) {
        //console.log(JSON.stringify(response.data));
        toast.success("Receipt Created Successfully.");
        navigate("/expenses");
      })
      .catch(function (error) {
        //  toast.error(JSON.stringify(error.response.data.message));
        toast.error(error?.response?.data?.message);
        errorLogApi(error, "IncomeAddChild", "/income/add");
        // console.log(error);
      });
  };

  const incomeSourceOptions = [
    { value: 1, label: "Cash" },
    { value: 2, label: "Cheque" },
    { value: 3, label: "Online Transfer" },
    { value: 4, label: "Demand Draft" },
  ];

  const paymentStatusOption = [
    { value: 1, label: "Pending" },
    { value: 2, label: "Settled" },
    { value: 3, label: "Declined" },
  ];

  return (
    <div className="flex justify-center w-full min-h-screen bg-gray-50">
      <div className="p-8 w-full max-w-2xl">
        <form
          onSubmit={(e) => handleUpdateExpense(e)}
          autoComplete="off"
          className="p-6 bg-white rounded-lg shadow-md"
        >
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-gray-800">Update Voucher</h2>
            <div className="space-x-2">
              <button
                type="button"
                className="px-4 py-2 text-gray-600 bg-gray-200 rounded-md transition duration-300 ease-in-out hover:bg-gray-300"
                onClick={() => navigate(-1)}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-white bg-blue-600 rounded-md transition duration-300 ease-in-out hover:bg-blue-700"
              >
                Update
              </button>
            </div>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Category
              </label>
              <Select
                name="category_id"
                onChange={(selected) =>
                  setFormData({ ...formData, category_id: selected.value })
                }
                options={categoryList}
                placeholder={placeHolderText("Select Category")}
                className="w-full"
                value={
                  formData?.category_id &&
                  categoryList?.find((c) => c.value === formData?.category_id)
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Expense Title
              </label>
              <div className="relative">
                <input
                  className="p-3 pl-10 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="expense_title"
                  type="text"
                  required
                  placeholder="Enter Expense Title"
                  onChange={handleChange}
                  value={formData?.expense_title}
                />
                <ClipboardDocumentIcon className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 transform -translate-y-1/2" />
              </div>
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Date
              </label>
              <div className="relative">
                <DatePicker
                  className="p-3 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="date"
                  value={formData?.date ? dayjs.utc(formData?.date) : null}
                  onChange={(date) => {
                    setStartDate(dayjs.utc(date));
                    setFormData({
                      ...formData,
                      date: date.utc().format("MM-DD-YYYY"),
                    });
                  }}
                  format="MM-DD-YYYY"
                  showToday={true}
                />
                <CalendarIcon className="absolute right-3 top-1/2 w-5 h-5 text-gray-400 transform -translate-y-1/2" />
              </div>
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Member
              </label>
              <Select
                name="member_id"
                onChange={(selected) =>
                  setFormData({ ...formData, member_id: selected.value })
                }
                options={churchMembers}
                placeholder={placeHolderText("Select Member")}
                className="w-full"
                value={
                  formData?.member_id &&
                  churchMembers?.find((m) => m.value === formData?.member_id)
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Amount
              </label>
              <div className="relative">
                <input
                  className="p-3 pl-10 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="amount"
                  type="number"
                  required
                  placeholder="Enter Amount"
                  onChange={handleChange}
                  value={formData?.amount}
                />
                <CurrencyDollarIcon className="absolute left-3 top-1/2 w-5 h-5 text-gray-400 transform -translate-y-1/2" />
              </div>
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Transfer Source
              </label>
              <Select
                name="transfer_source"
                onChange={(selected) =>
                  setFormData({ ...formData, transfer_source: selected.label })
                }
                options={incomeSourceOptions}
                placeholder={placeHolderText("Select Source")}
                className="w-full"
                value={
                  formData?.transfer_source &&
                  incomeSourceOptions?.find(
                    (i) => i.label === formData?.transfer_source
                  )
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Payment Status
              </label>
              <Select
                name="status"
                onChange={(selected) =>
                  setFormData({ ...formData, status: selected.value })
                }
                options={paymentStatusOption}
                placeholder={placeHolderText("Select Status")}
                className="w-full"
                value={
                  formData?.status &&
                  paymentStatusOption.find(
                    (p) => p.value === parseInt(formData?.status)
                  )
                }
                styles={{
                  control: (base) => ({
                    ...base,
                    borderColor: "#D1D5DB",
                    borderRadius: "0.375rem",
                    "&:hover": { borderColor: "#9CA3AF" },
                  }),
                }}
              />
            </div>

            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">
                Description
              </label>
              <div className="relative">
                <textarea
                  className="p-3 pl-10 w-full rounded-md border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  name="description"
                  rows={3}
                  placeholder="Expense Description"
                  onChange={handleChange}
                  value={formData?.description}
                />
                <ClipboardDocumentIcon className="absolute top-3 left-3 w-5 h-5 text-gray-400" />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ExpenseUpdateChild;
